import { Config } from '../../../config'
import styled from 'styled-components'

const { palette } = Config as any

export const Typography = styled.p<TypographyProps>`
  color: ${(props) => palette[props.color || ''] || 'inherit'};

  ${(props) => {
    const variant = `${props.variant}` || 'base'

    if (variant === '1')
      return `
                font-size: 3.2rem;
                line-height: 1.125;
            `

    if (variant === '2')
      return `
                font-size: 2.8rem;
                line-height: 1.428571;
            `

    if (variant === '3')
      return `
                font-size: 2.4rem;
                line-height: 1.6667;
            `

    if (variant === '4')
      return `
                font-size: 2rem;
                line-height: 1.2;
            `

    if (variant === '5')
      return `
                font-size: 1.8rem;
                line-height: 1.5;
            `

    if (variant === '6')
      return `
                font-size: 1.6rem;
            `

    if (variant === '7')
      return `
                font-size: 1.5rem;
            `

    if (variant === '8')
      return `
                font-size: 1.2rem;
            `
    if (variant === '9')
      return `
                font-size: 1rem;
            `

    if (variant === 'base')
      return `
                font-size: 1.4rem;
            `
  }}
`

export type TypographyProps = {
  variant?:
    | '1'
    | '2'
    | '3'
    | '4'
    | '5'
    | '6'
    | '7'
    | '8'
    | '9'
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 'base'
  color?:
    | 'light'
    | 'danger'
    | 'primary'
    | 'secondary'
    | 'disabled'
    | 'hint'
    | 'greyTitle'
}
